import { icons } from '@assets/icons';
import { memo } from 'react';

const BusinessSearchField = memo(
  ({ value = '', onChange, placeholder = 'Search business or location' }) => (
    <div className="w-full">
      <label htmlFor="business-search" className="sr-only">
        {placeholder}
      </label>
      <div className="box-border flex h-11 w-full items-center gap-2 desktop:gap-[10px] rounded-full border border-merchant-border bg-white px-3 desktop:px-4 desktop:h-12">
        <img src={icons.search} alt="" className="icon-md shrink-0 opacity-90" aria-hidden="true" />
        <input
          id="business-search"
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete="off"
          className="min-w-0 flex-1 border-0 bg-transparent text-body font-medium leading-5 desktop:leading-[26px] text-merchant-text-primary outline-none placeholder:text-[#c2c6cf]"
        />
      </div>
    </div>
  ),
);

BusinessSearchField.displayName = 'BusinessSearchField';

export default BusinessSearchField;
